module.exports = __webpack_public_path__ + "img/basic_skinmask_tube_202311.b5227508.jpg";